var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tabsview"
  }, [_c('v-tabs', {
    key: _vm.tabs.map(function (tab) {
      return tab.name;
    }).join(','),
    attrs: {
      "color": "primary",
      "optional": _vm.allowEmpty,
      "value": _vm.tabindex,
      "show-arrows": ""
    },
    on: {
      "change": _vm.onTabChange
    },
    nativeOn: {
      "touchstart": function touchstart($event) {
        return _vm.onTabBarTouchStart.apply(null, arguments);
      },
      "touchmove": function touchmove($event) {
        return _vm.onTabBarTouchMove.apply(null, arguments);
      }
    }
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('v-tab', {
      key: "".concat(index),
      staticClass: "px-0 mr-4",
      attrs: {
        "disabled": tab.disabled
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " "), tab.counter || tab.showCounter ? _c('v-chip', {
      staticClass: "ml-2 justify-center",
      "class": _vm.textColorClass(tab),
      attrs: {
        "small": "",
        "color": _vm.color(tab),
        "outlined": _vm.outlined(tab)
      }
    }, [_vm._v(" " + _vm._s(tab.counter))]) : _vm._e()], 1);
  }), 1), !_vm.allowEmpty || _vm.tabindex >= 0 ? _c('v-tabs-items', {
    attrs: {
      "value": _vm.tabindex,
      "touchless": ""
    }
  }, [_vm._t("tabs")], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }